import moment from 'moment'
import { SO_FAR, TOKEN } from '@/store/mutation-types'
import store from '@/store/index'
import { notification, Modal } from 'ant-design-vue'
import Vue from 'vue'
import CryptoJS from 'crypto-js'
import Viewer from 'viewerjs'
import 'viewerjs/dist/viewer.css'
import VisitorApi from '@/api/visitor'
// @ts-ignore
import watermark from '@/utils/watermarkjs'
const Item2UIDMap = new WeakMap()

export function timeFix() {
	const time = new Date()
	const hour = time.getHours()
	return hour < 9
		? '早上好'
		: hour <= 11
		? '上午好'
		: hour <= 13
		? '中午好'
		: hour < 20
		? '下午好'
		: '晚上好'
}

export function welcome() {
	const arr = [
		'休息一会儿吧',
		'准备吃什么呢?',
		'要不要打一把 DOTA',
		'我猜你可能累了',
	]
	const index = Math.floor(Math.random() * arr.length)
	return arr[index]
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent() {
	const event: any = document.createEvent('HTMLEvents')
	event.initEvent('resize', true, true)
	event.eventType = 'message'
	window.dispatchEvent(event)
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate(id = '', timeout = 1500) {
	if (id === '') {
		return
	}
	setTimeout(() => {
		const node: any = document.getElementById(id)
		document.body.removeChild(node)
	}, timeout)
}

export const checkCarNo = (carNo: string) => {
	// 新能源纯电：D、A、B、C、E
	// 新能源非纯：F、G、H、J、K
	// [0-9]{5}[DABCEFGHJK] - 大型新能源汽车
	// [DABCEFGHJK]([A-HJ-NP-Z0-9])[0-9]{4} - 小型新能源汽车
	return /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DABCEFGHJK])|([DABCEFGHJK]([A-HJ-NP-Z0-9])[0-9]{4})|([A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳领]{1})))$/.test(
		carNo
	)
}

export async function hasVisitor(rule: any, value: any, callback: Function) {
	// 所选地区是否有作业人员
	const codes = value.key && value.key.split('-')
	const provinceCode = codes[0]
	const cityCode = codes[1]
	const areaCode = codes[2]
	let res = await VisitorApi.hasVisitorInArea({
		provinceCode,
		cityCode,
		areaCode,
	})
	if (res.data) {
		return callback()
	} else {
		return callback(
			new Error('该地区暂时不具备条件作业，如有需要请联系中保车服工作人员。')
		)
	}
}

export const uuid = () => {
	const s: any = []
	const hexDigits = '0123456789abcdef'
	for (let i = 0; i < 36; i++) {
		s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
	}
	s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
	/* tslint:disable */
	s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
	s[8] = s[13] = s[18] = s[23] = '-'

	const res = s.join('')
	return res
}

export function hasValue(value: any) {
	return (value && String(value).trim()) || value === 0
}

export const menuCodeToPermissions = (resources: any[]) => {
	resources = resources
		.map((sub: any) => sub.menuCode)
		.filter((menuCode: any) => Boolean(menuCode))

	const menuPermissions: any = []
	const actionPermissions: any = {}
	for (const item of resources) {
		const arr = item.split(':')
		const p = arr.shift() // 菜单权限
		if (p === 'injury') {
			continue
		}
		const action = arr.join(':') // 按钮权限
		if (action) {
			if (!actionPermissions[p]) {
				actionPermissions[p] = []
			}
			actionPermissions[p].push(action)
		} else {
			menuPermissions.push(p)
		}
	}

	return {
		menuPermissions,
		actionPermissions,
	}
}

export function throttle(wait: number) {
	let running = false
	return (callback: any) => {
		if (running) {
			return
		}
		running = true
		callback && callback()
		setTimeout(() => {
			running = false
		}, wait)
	}
}

export function debounce(wait: number) {
	let timer: any = ''
	return (callback: any) => {
		clearTimeout(timer)
		timer = setTimeout(() => {
			callback && callback()
		}, wait)
	}
}

export function download(blob: any, filename: string) {
	if (navigator.msSaveBlob) {
		return navigator.msSaveBlob(blob, filename)
	} else {
		const a = document.createElement('a')
		a.addEventListener('click', () => {
			a.download = filename
			a.href = URL.createObjectURL(blob)
		})
		const e = document.createEvent('MouseEvents')
		e.initEvent('click', false, false)
		a.dispatchEvent(e)
		a.remove()
	}
}

export function getExpandTime() {
	let timer: any = ''
	return () => {
		clearTimeout(timer)
		timer = setTimeout(() => {
			store.dispatch('user/Logout').then(() => {
				;(Modal as any).destroyAll()
				Modal.warning({
					title: '提示',
					content: '您长时间未操作自动退出，请重新登录',
					onOk() {
						window.location.replace(`${location.origin}/passport/login`)
					},
					okText: '确认',
				})
			})
		}, 24 * 60 * 60 * 1000)
		// 50 * 60 * 1000
	}
}

export function dateFormat(start: any, end: any, pattern = 'YYYY-MM') {
	if (!start && !end) {
		return
	} else if (end >= SO_FAR) {
		return moment(start).format(pattern) + '-至今'
	} else if (!start) {
		return '至' + moment(end).format(pattern)
	} else {
		return moment(start).format(pattern) + '至' + moment(end).format(pattern)
	}
}

export const aesEncrypt = (data: any, key: any) => {
	const encrypted = CryptoJS.AES.encrypt(data, key, {
		mode: CryptoJS.mode.ECB,
		padding: CryptoJS.pad.Pkcs7,
	})
	return encrypted.toString()
}

export const aesDecrypt = (encrypted: any, key: any) => {
	let decrypted = CryptoJS.AES.decrypt(encrypted, key, {
		mode: CryptoJS.mode.ECB,
		padding: CryptoJS.pad.Pkcs7,
	})
	decrypted = CryptoJS.enc.Utf8.stringify(decrypted) // 转换为 utf8 字符串
	return decrypted
}

export function GetQueryString(name: any) {
	const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
	const r = window.location.search.substr(1).match(reg)
	if (r != null) {
		return decodeURIComponent(r[2])
	}
	return null
}

export function updateViewer(viewer: any, selector: any) {
	if (!viewer) {
		const dom: any = document.querySelector(selector)
		if (dom) {
			return setViewer(dom)
		}
		return viewer
	} else {
		viewer.update()
		return viewer
	}
}

export function setViewer(dom: any, viewer?: any) {
	const options: any = {
		title(image: any) {
			return image.alt
		},
		url(image: any) {
			return image.src.replace(/\?imageMogr2\S+/, '')
		},
		toolbar: {
			oneToOne: {
				size: 'large',
			},
			reset: {
				size: 'large',
			},
			prev: {
				size: 'large',
			},
			play: {
				size: 'large',
			},
			next: {
				size: 'large',
			},
			rotateLeft: {
				size: 'large',
			},
			rotateRight: {
				size: 'large',
			},
		},
	}
	viewer && viewer.destroy()
	return new Viewer(dom, options)
}

export function getStyleProperty(el: any, styleName: string) {
	if (!el) {
		return
	}
	const style: any = window.getComputedStyle(el) || el.currentStyle
	return style && style[styleName]
}

export function getSideMenuWidth() {
	let sideMenu = document.querySelector('.ant-layout-sider')
	let width = getStyleProperty(sideMenu, 'width')
	return width
}

export function getUID(item: any) {
	const persistedUID = Item2UIDMap.get(item)
	if (!persistedUID) {
		const res = uuid()
		Item2UIDMap.set(item, res)
		return res
	}
	return persistedUID
}

export const checkFile = function(file: any) {
	return new Promise((resolve, reject) => {
		let reader = new FileReader()
		reader.readAsDataURL(file)
		reader.onload = async function(e) {
			getImgData(e)
				.then(res => {
					resolve(res)
				})
				.catch(e => {
					reject(e)
				})
		}
	})
}
// 图片的base64
export const getImgData = function(e: any) {
	return new Promise(resolve => {
		var image = new Image()
		image.src = e.target.result
		image.onload = function() {
			const canvas = document.createElement('canvas')
			const ctx = canvas.getContext('2d')

			let rate = 0.97
			let step = 0.02

			let base64 = canvas.toDataURL('image/jpeg', rate)
			let filecontent = dataURLtoBlob(base64)

			for (let i = 0; i < 10; i++) {
				if (filecontent.size <= 1024 * 200) {
					break
				}
				rate -= step
				base64 = canvas.toDataURL('image/jpeg', rate)
				filecontent = dataURLtoBlob(base64)
			}
			resolve(filecontent)
		}
	})
}
export const dataURLtoBlob = function(dataurl: any) {
	var arr = dataurl.split(','),
		mime = arr[0].match(/:(.*?);/)[1],
		bstr = atob(arr[1]),
		n = bstr.length,
		u8arr = new Uint8Array(n)
	while (n--) {
		u8arr[n] = bstr.charCodeAt(n)
	}
	const blob = new Blob([u8arr], { type: mime })
	return blob
}
export const drawWatermark = function(image: any, logo: any, obj: any) {
	var context = image.getContext('2d')
	context.save()
	let fontSize = 12
	const hPad = 10
	const vPad = 8

	const limitWidth = image.width / 2 - hPad * 2 - 30
	context.font = `${fontSize}px simhei`

	const lastText = `${obj.address}(${obj.latlng})`

	let lastTextWidth = context.measureText(lastText).width
	let lastTextMidWidth = Math.ceil(lastTextWidth / 2)

	while (lastTextMidWidth > limitWidth && fontSize > 12) {
		fontSize -= 2
		context.font = `${fontSize}px simhei`
		lastTextWidth = context.measureText(lastText).width
		lastTextMidWidth = Math.ceil(lastTextWidth / 2)
	}

	let barHeight = fontSize * 3 + vPad * 4
	let logoHeight = Math.min(58, barHeight * 0.6)
	let logoWidth = (logoHeight * logo.width) / logo.height

	context.globalAlpha = 0.4
	context.fillStyle = '#000'
	context.fillRect(0, image.height - barHeight, image.width, barHeight)

	context.globalAlpha = 1
	context.fillStyle = '#fff'
	context.textBaseline = 'top'
	context.drawImage(
		logo,
		hPad,
		image.height - logoHeight - (barHeight - logoHeight) / 2,
		logoWidth,
		logoHeight
	)
	context.fillText(
		'报案号：' + obj.caseNo,
		hPad * 2 + logoWidth,
		image.height - barHeight + vPad + hPad
	)
	context.fillText(
		obj.picName,
		image.width / 2 + logoWidth,
		image.height - barHeight + vPad + hPad
	)
	context.fillText(
		obj.time,
		hPad * 2 + logoWidth,
		image.height - barHeight + vPad + hPad * 2 + fontSize
	)
	context.fillText(
		obj.visitorInfo,
		image.width / 2 + logoWidth,
		image.height - barHeight + vPad + hPad * 2 + fontSize
	)
	context.restore()
	return image
}
export const uploadImage = async function(obj: any) {
	const blob = await watermark([
		obj.file,
		'/demo/rslogo.svg',
	]).blob((image: any, logo: any) => drawWatermark(image, logo, obj))
	let formData = new FormData()
	formData.append('filecontent', blob, obj.picName)
	return formData
}
